import {useInfiniteQuery, useQueryClient} from '@tanstack/react-query';
import repositories from '../../repositories.jsx';
import Projects from '../../components/Projects.jsx';
import EmptyProjects from '../../components/EmptyProjects.jsx';
import _ from 'lodash';
import PageLoader from '../../components/PageLoader.jsx';
import Header from '../../components/Header.jsx';
import {useEffect, useMemo, useRef, useState} from 'react';
import {useIntersection} from '@mantine/hooks';
import BaseModal from '../../widgets/BaseModal.jsx';
import {useGlobalAudioPlayer} from 'react-use-audio-player';
import PrimaryCard from '../../components/PrimaryCard.jsx';

export default function Dashboard() {
	const [isGeneratingVideo, setIsGeneratingVideo] = useState(30000)
	const queryClient = useQueryClient();
	
	const {stop} = useGlobalAudioPlayer()
	
	const containerRef = useRef(null);
	const {ref, entry} = useIntersection({
		threshold: 0.2,
	});
	
	const projects = useInfiniteQuery({
		queryKey: ['projects'],
		queryFn: ({pageParam}) => repositories.project.list({page: pageParam, per_page: 20}).then(res => {
			setIsGeneratingVideo(_.some(res?.rows, item => (item?.status === "in_progress" || projects.data?.export_status == 'in_progress' || projects.data?.export_status == 'rendering')) ? 30000 : false)
			queryClient.refetchQueries({
				queryKey: ['auth']
			})
			return res;
		}).catch((error) => {
			console.log(error)
		}),
		refetchInterval: isGeneratingVideo,
		initialPageParam: 1,
		getNextPageParam: (lastPage, pages, lastPageParam) => lastPage?.rows?.length > 12 ? lastPageParam + 1 : null,
	})
	
	useEffect(() => {
		setTimeout(() => {
			projects?.hasNextPage && projects.isFetched && entry?.isIntersecting && projects.fetchNextPage()
		}, 1000)
	}, [entry?.isIntersecting]);
	
	useEffect(() => {
		setTimeout(() => {
			queryClient.refetchQueries({
				queryKey: ['auth']
			})
		}, 1000)
	}, []);
	
	const allProjects = useMemo(() => {
		return _.flatMap(projects?.data?.pages, (item) => item?.rows || []);
	}, [projects.data])
	
	return (
		<>
			<Header className={_.size(allProjects) > 0 && "border-b border-white"}/>
			
			<div className="relative overflow-y-auto overflow-x-hidden" ref={containerRef}>
				<PrimaryCard className="border-2s border-whites bg-whited !shadow-none">
					{projects?.isLoading ?
						<div className="w-full h-full top-0 left-0 fixed z-50 transition-all duration-300">
							<PageLoader/>
						</div>
						:
						<div className=" relative">
							<div className="col-span-full flex flex-wrap justify-between items-center mb-5 gap-3">
								<h2 className="text-lg font-bold text-slate-800 tracking-tight">All Dubs</h2>
								<BaseModal
									triggerProps={{
										className: "rounded-full bg-gradient-to-r from-primary to-fuchsia-500 text-white font-semibold px-6 shadow-lg shadow-fuchsia-500/30 hover:scale-[1.02] transition-transform"
									}}
									triggerContent={<>
										<i className="eva eva-plus-outline text-xl"></i>
										New project
									</>}
								/>
							</div>
							{_.size(allProjects) > 0 ?
								<>
									<Projects data={allProjects || []}/>
									{projects.hasNextPage &&
										<div ref={ref} className="w-full flex justify-center items-center py-4">
											<PageLoader size="md"/>
										</div>
									}
								</>
								:
								<div className="rounded-20 bg-white p-6">
									<div
										className="text-center flex-grow h-[initial] border-dashed border-2  overflow-hidden border-slate-500/30 rounded-20 cursor-pointer flex flex-col items-center justify-center">
										<EmptyProjects
											icon={<img src="/images/no-result.jpg" alt="upload-icon"
											           className="max-w-44 mx-auto mb-5"/>}
											title='Get stated with your first project'
											children='Upload your first project and start dubbing your video effortlessly. Bring your content to life with just a few clicks!'
											className="bg-white bg-[url()] w-full h-full min-h-[600px] py-32"
											actionChildren={
												<BaseModal
													triggerProps={{
														className: "rounded-full bg-gradient-to-r from-primary to-fuchsia-500 text-white px-10 py-6 font-semibold shadow-lg shadow-fuchsia-500/30 hover:scale-[1.02] transition-transform",
													}}
													triggerContent={<>
														<i className="eva eva-arrow-forward text-xl"></i>
														Get Started
													</>}
												/>
											}
										/>
									</div>
								</div>
							}
						</div>
					}
				</PrimaryCard>
			</div>
		
		</>
	);
}
